import { useQuery } from '@tanstack/react-query';
import { kpiApi, kpiQueryKeys } from '../api';
import type { FirmKpiSummaryParams, KpiSummaryParams } from '../types';

export function useKpiSummary(params: KpiSummaryParams, enabled = true) {
  return useQuery({
    queryKey: kpiQueryKeys.summary(params),
    queryFn: () => kpiApi.getSummary(params),
    enabled: enabled && !!params.userId,
    placeholderData: (prev) => prev,
  });
}

// Firm-wide aggregate KPI (no user selected) — gated to `kpi:get:all` callers.
export function useFirmKpiSummary(params: FirmKpiSummaryParams, enabled = true) {
  return useQuery({
    queryKey: kpiQueryKeys.firmSummary(params),
    queryFn: () => kpiApi.getFirmSummary(params),
    enabled,
    placeholderData: (prev) => prev,
  });
}

export function useMonthlyKPI(userId?: number) {
  return useQuery({
    queryKey: kpiQueryKeys.monthlyKpi(userId!),
    queryFn: () => kpiApi.getMonthlyKPI(userId),
    placeholderData: (prev) => prev,
  });
}
